import { hasGates } from 'utils/Access'

export const HAS_CONSENT_ATTRIBUTE_NAME = 'has_consent'

export const REQUIREMENT_TYPES = Object.freeze({
  NONE: 'NONE',
  EU: 'EU',
  CANADA: 'CANADA',
  EU_CANADA: 'EU_CANADA',
  ALL: 'ALL',
})

export const AUDIENCE_OPTIONS = Object.freeze([
  { value: REQUIREMENT_TYPES.NONE, label: 'No One' },
  { value: REQUIREMENT_TYPES.EU, label: 'Visitors in the European Union' },
  { value: REQUIREMENT_TYPES.CANADA, label: 'Visitors in Canada' },
  {
    value: REQUIREMENT_TYPES.EU_CANADA,
    label: 'Visitors in the European Union and Canada',
  },
  { value: REQUIREMENT_TYPES.ALL, label: 'Everyone' },
])

export const WARNING_TEXT = {
  NO_FORMS:
    'You must create a consent form before you can require it for an audience.',
  NO_REQUIREMENT_WITH_FORMS:
    'Just a heads up: your consent forms are not visible because you’ve chosen not to require consent from anyone.',
}

export const TABLE_COLUMNS = [
  { label: 'Language', width: '42%' },
  { label: 'Status', width: '42%' },
  { width: 'auto' },
]

export const DISPLAY_OPTIONS = Object.freeze({
  BROWSER: 'BROWSER',
  WIDGET: 'WIDGET',
})

export const DATA_CONSENT_ROUTE = 'edit'
export const DATA_CONSENT_V3_ROUTE = 'consent-form'
export const DATA_PRIVACY_V3_ROUTE = 'data-privacy'

export const getDataConsentUrl = (language) =>
  hasGates('has_widget_v3')
    ? `${DATA_CONSENT_V3_ROUTE}/${language}`
    : `${DATA_CONSENT_ROUTE}/${language}`
